import React from 'react';
import { WriterLoader } from '../components/WriterLoader';

export default function DesignShowcase() {
  return (
    <div className="p-12 space-y-12">
      <section>
        <h2 className="text-2xl mb-4 font-display">WriterLoader Gallery</h2>
        <div className="flex items-center gap-12 border border-[var(--border-subtle)] p-12 rounded-xl bg-[var(--surface-card)]">
          <WriterLoader size="sm" message="Small size..." />
          <WriterLoader size="md" message="Medium size..." />
          <WriterLoader size="lg" message="Large size..." />
        </div>
      </section>
    </div>
  );
}
